/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2021
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Defines the IDs for features in the model objects.  Each feature ID is prefixed by the model class name, followed by the feature name.   They can be used to identify the feature to be changed through the generic set(), add() and remove() methods on each model object.
 */
export default class Features extends BaseMoserObject{

	static PARAMETER_VALUE = 1;

	static CONTEXT = 2;

	static ITEM = 3;

	static RESOURCE_LANGUAGE = 4;

	static NAME = 5;

	static ORIGINAL_NAME = 6;

	static DESCRIPTION = 7;

	static HIDDEN = 8;

	static MSG = 9;

	static SEVERITY = 10;

	static DETAIL_MSG = 11;

	static ERROR_CODE = 12;

	static LOCATION = 13;

	static RULE_ID = 14;

	static TYPE = 15;

	static ERROR_DATA = 16;

	static ENABLED = 17;

	static SORT_LIST = 18;

	static PROMPT_TYPE = 19;

	static PROMPT_CASCADE_ON_REF = 20;

	static PROMPT_FILTER_ITEM_REF = 21;

	static PROMPT_USE_ITEM_REF = 22;

	static PROMPT_DISPLAY_ITEM_REF = 23;

	static FILTER = 24;

	static CALCULATION = 25;

	static NAMED_SET = 26;

	static ITEM_HIERARCHY = 27;

	static QUERY_ITEM = 28;

	static FOLDER = 29;

	static USE_EXPRESSION = 30;

	static DISPLAY_EXPRESSION = 31;

	static SORT_EXPRESSION = 32;

	static IS_UNIQUE = 33;

	static INDEXED_COLUMN = 34;

	static VALUE = 35;

	static REF = 36;

	static KEY_REF = 37;

	static IDENTIFIER = 38;

	static TEXT = 39;

	static NULL_PLACEMENT = 40;

	static ORDER = 41;

	static SECURITY_OBJECT = 42;

	static EXPRESSION = 43;

	static SECURITY_FILTER = 44;

	static GENERATE_SQL = 45;

	static SOURCE_CATEGORY = 46;

	static QUERY_OPERATION = 47;

	static SHORTCUT_TARGET_QUERY_SUBJECT_REF = 48;

	static QUERY_SUBJECT_USAGE = 49;

	static SELECT_LIST_CONTROL = 50;

	static USE_IN_JOIN_PATH = 51;

	static CLASSIFIER = 52;

	static ROW_COUNT = 53;

	static ITEM_NORMALIZATION = 54;

	static USE_LOCAL_CACHE = 55;

	static SQL_QUERY = 56;

	static COLUMN_DEPENDENCY = 57;

	static INSTANCE_TYPE = 58;

	static JOIN_OPERATION = 59;

	static ORIGINAL_REF = 60;

	static NUMBER_OF_ROWS = 61;

	static DATA_CACHE_EXPIRY = 62;

	static LOOKUP_TABLE_ID = 63;

	static DATATYPE = 64;

	static COLUMN_NAME_PATTERN = 65;

	static LOOKUP_MODULE = 66;

	static LOOKUP_COLUMN_ID = 67;

	static JOIN_RELATIONSHIP = 68;

	static NUMBER_OF_DISTINCT_VALUES = 69;

	static REF_TO_HIERARCHY = 70;

	static FOLDER_ITEM = 71;

	static CALCULATED_MEMBER = 72;

	static LOCAL_REF = 73;

	static NULLABLE = 74;

	static HIGHLEVEL_DATATYPE = 75;

	static EXTERNAL_NAME = 76;

	static USAGE = 77;

	static REGULAR_AGGREGATE = 78;

	static DEF_LINK = 79;

	static PARAMETER_NAME = 80;

	static INVERT = 81;

	static DATA_TYPE = 82;

	static VALUES = 83;

	static SPLIT_RULES = 84;

	static IMPORTS = 85;

	static SEARCH_PATH = 86;

	static PROPERTY = 87;

	static STORE_ID = 88;

	static ANCESTORS = 89;

	static LOAD_AS_NEEDED = 90;

	static PARAMETER_MAP_ENTRY = 91;

	static FRESHNESS = 92;

	static QUERY_ITEM_MAP = 93;

	static DEFAULT_VALUE = 94;

	static ID_FOR_EXPRESSION = 95;

	static CONNECTION_STRING = 96;

	static SCHEMA = 97;

	static STORED_PROCEDURE = 98;

	static CATALOG = 99;

	static CUBE_PATH = 100;

	static JDBC = 101;

	static CUBE_DATA_UPDATED_ON = 102;

	static CUBE_CREATED_ON = 103;

	static CUBE_DEFAULT_MEASURE = 104;

	static DATABASE_TYPE = 105;

	static CUBE_SCHEMA_UPDATED_ON = 106;

	static CM_DATA_SOURCE = 107;

	static CSV_URL = 108;

	static PASSWORD = 109;

	static CUBE_DESCRIPTION = 110;

	static CUBE_IS_OPTIMIZED = 111;

	static DB_FUNCTION = 112;

	static CUBE = 113;

	static CUBE_CURRENT_PERIOD = 114;

	static USER = 115;

	static TABLE = 116;

	static CAPABILITIES = 117;

	static MODEL_FILTER_ITEM = 118;

	static DIRECTION = 119;

	static SIGNIFICANT = 120;

	static INTENT = 121;

	static INFLUENTIAL = 122;

	static JDBC_URL = 123;

	static DRIVER_CLASS_NAME = 124;

	static CONNECTION_PROPERTIES = 125;

	static FAMILY = 126;

	static CLAZZ = 127;

	static DOMAIN = 128;

	static CONTAINER = 129;

	static USE = 130;

	static FM_MODEL = 131;

	static USE_SPEC = 132;

	static RELATIONSHIP = 133;

	static PARAMETER_MAP = 134;

	static METADATA_TREE_VIEW_FOCUS = 135;

	static REF_ACTIVE_PARAMETER_VALUE_SET = 136;

	static EXPRESSION_LOCALE = 137;

	static DRILL_GROUP = 138;

	static VERSION = 139;

	static PARAMETER_VALUE_SET = 140;

	static DATA_RETRIEVAL_MODE = 141;

	static TEXT_RESOURCE = 142;

	static QUERY_SUBJECT = 143;

	static DATA_SOURCE = 144;

	static PROMPT = 145;

	static METADATA_TREE_VIEW = 146;

	static KEY = 147;

	static LINE = 148;

	static CHARACTER = 149;

	static LEFT_REF = 150;

	static RIGHT_REF = 151;

	static COMPARISON_OPERATOR = 152;

	static ITEM_REF = 153;

	static KEY_CONSTRAINT = 154;

	static KEY_COMPOSITION = 155;

	static BOUND_RANGE = 156;

	static OPTIONAL = 157;

	static DISCRETE_VALUE = 158;

	static UNBOUNDED_RANGE = 159;

	static MULTIVALUED = 160;

	static SQL_OPERATOR = 161;

	static PROC_PARAMETER = 162;

	static RESULT_DATATYPE = 163;

	static KEYED_COLUMN = 164;

	static TABLE_ITEM = 165;

	static PROPERTY_OVERRIDE = 166;

	static EDIT_MODE = 167;

	static COMMENT = 168;

	static LABEL = 169;

	static SCREEN_TIP = 170;

	static DATASOURCE_REF = 171;

	static SQL_TEXT = 172;

	static SQL_TYPE = 173;

	static PROJECTED_ITEM = 174;

	static ITEM_NORMALIZATION_GROUP = 175;

	static DATA = 176;

	static VENDOR_TYPE = 177;

	static VENDOR_FORMAT = 178;

	static FOLDER_LABEL = 179;

	static RELATIONSHIP_REF = 180;

	static COLUMN_TREATMENT = 181;

	static DISPLAY = 182;

	static MODE = 183;

	static SORT_ITEM = 184;

	static SET_OPERATION = 185;

	static DUPLICATES = 186;

	static QUERY_REF = 187;

	static MINIMUM_VALUE = 188;

	static NUMBER_OF_NULL_VALUES = 189;

	static ROOT_MEMBER = 190;

	static CONCEPTS = 191;

	static HIERARCHY_HAS_MULTIPLE_ROOTS = 192;

	static MEMBERS = 193;

	static ORDERED_VALUES = 194;

	static MAXIMUM_VALUE = 195;

	static TABLE_TYPE = 196;

	static COLUMN = 197;

	static INDEX = 198;

	static FOREIGN_KEY = 199;

	static PRIMARY_KEY = 200;

	static STRUCT = 201;

	static MULTISET = 202;

	static SEGMENT = 203;

	static USE2 = 204;

	static DISPLAY2 = 205;

	static OPERATOR = 206;

	static MINCARD = 207;

	static MAXCARD = 208;

	static CM_SEARCH_PATH = 209;

	static DISPLAY_PATH = 210;

	static PARENT_GROUP_REF = 211;

	static ATTRIBUTE = 212;

	static CARDINALITY = 213;

	static VALIDATION_MESSAGE = 214;

	static PK_CATALOG = 215;

	static PK_SCHEMA = 216;

	static PK_COLUMN = 217;

	static PK_TABLE = 218;

	static COLUMN_NAME = 219;

	static FK_COLUMN = 220;

	static DEFAULT_NAME = 221;

	static LEVEL_LABEL = 222;

	static DIMENSION_UNIQUE_NAME = 223;

	static PARENT_UNIQUE_NAME = 224;

	static MEMBER_CAPTION = 225;

	static LEVEL_NUMBER = 226;

	static LEVEL_UNIQUE_NAME = 227;

	static PARENT_LEVEL = 228;

	static HIERARCHY_UNIQUE_NAME = 229;

	static POST_AUTO_AGGREGATION = 230;

	static VALUE_REF = 231;

	static LEFT = 232;

	static LINK = 233;

	static RIGHT = 234;

	static JOIN_FILTER_TYPE = 235;

	static SHORTCUT_TARGET_RELATIONSHIP_REF = 236;

	static SORT_ORDER = 237;

	static UI_CONTROL_REFERENCE = 238;

	static QUERY_VALUE_SELECTOR = 239;

	static REF_DRILL_GROUP = 240;

	static UPPER_LIMIT = 241;

	static LOWER_LIMIT = 242;

	static STATIC_VALUE_SELECTOR = 243;

	static ROLE = 244;

	static FORMAT = 245;

	static TAXONOMY = 246;

	static AGGREGATE_MODE = 247;

	static SPLIT_DEFINITION = 248;

	static FACET_DEFINITION = 249;

	static DATATYPE_CATEGORY = 250;

	static PROMPT_INFO = 251;


}


// WEBPACK FOOTER //
// ./src/generated/Features.js